import {
  SHARED_HERO_SUBHEADING,
  SHARED_HERO_INTRO,
  SHARED_HERO_CREDIBILITY,
  SHARED_HERO_BOTTOM_PARAGRAPH,
} from "./medicalHeroContent";

/**
 * Hero content sent from each page to the hero section. Same for all pages for now;
 * change heroSubheading, heroIntro, heroImage, heroCredibility, heroBottomParagraph per page when needed.
 * heroImage: omit or leave undefined to use the default main hero image; set to a URL for a custom image.
 */
const DEFAULT_HERO = {
  heroSubheading: SHARED_HERO_SUBHEADING,
  heroIntro: SHARED_HERO_INTRO,
  heroCredibility: SHARED_HERO_CREDIBILITY,
  heroBottomParagraph: SHARED_HERO_BOTTOM_PARAGRAPH,
};

export const MEDICAL_PAGES = {
  "jetzt-einstellen": {
    ...DEFAULT_HERO,
    title: "Jetzt einstellen",
    intro:
      "Besetzen Sie Ihre Schlüsselpositionen im Healthcare-Bereich mit REPEXO Medical. Wir unterstützen Sie mit strukturierter Direktansprache und langjähriger Branchenerfahrung.",
    paragraphs: [
      "Ob Facharzt, Medizintechniker oder Führungskraft—wir finden die passenden Kandidaten für Ihre Anforderungen. Unser Prozess ist transparent, schnell und diskret.",
      "Starten Sie mit einer unverbindlichen Erstberatung. Wir analysieren Ihre Bedarfe und schlagen einen maßgeschneiderten Rekrutierungsansatz vor.",
    ],
  },
  "stellenangebote": {
    ...DEFAULT_HERO,
    title: "Stellenangebote",
    intro:
      "Aktuelle offene Positionen, die wir für Mandanten im Healthcare-Bereich besetzen. Hier finden Sie eine Auswahl unserer aktuellen Suchaufträge.",
    paragraphs: [
      "Unsere Stellenangebote umfassen Fach- und Führungspositionen in Kliniken, Pharma, Medizintechnik und wissenschaftlichen Einrichtungen.",
      "Sie suchen einen Kandidaten für eine spezifische Rolle? Kontaktieren Sie uns—wir erweitern unsere Suchaufträge laufend und arbeiten auch an unveröffentlichten Mandaten.",
    ],
  },
  "executive-search": {
    ...DEFAULT_HERO,
    title: "Executive Search",
    intro:
      "Executive Search für den Healthcare-Sektor: Wir identifizieren und gewinnen Führungskräfte, die strategisch und kulturell zu Ihrem Unternehmen passen.",
    paragraphs: [
      "Unser Executive-Search-Prozess kombiniert Marktkenntnis, diskrete Direktansprache und strukturierte Bewertung. So sichern wir langfristig erfolgreiche Besetzungen.",
      "Wir arbeiten national und international und haben Zugang zu Kandidaten, die über klassische Stellenportale nicht erreichbar sind.",
    ],
  },
  direktansprache: {
    title: "Direktansprache",
    intro:
      "Direktansprache (Headhunting) ist unser Kerngeschäft. Wir kontaktieren qualifizierte Kandidaten gezielt und diskret—ohne öffentliche Ausschreibung.",
    paragraphs: [
      "Durch gezielte Recherche und ein starkes Netzwerk erreichen wir Fach- und Führungskräfte, die nicht aktiv suchen, aber für die richtige Gelegenheit offen sind.",
      "Unser Vorgehen ist transparent und respektvoll: Kandidaten werden klar über Mandant und Rolle informiert, bevor vertiefte Gespräche geführt werden.",
    ],
  },
  nachfolgeplanung: {
    ...DEFAULT_HERO,
    title: "Nachfolgeplanung",
    intro:
      "Nachfolge in Praxis, Institut oder Abteilung sicher planen. Wir unterstützen Sie bei der Identifikation und Einarbeitung von Nachfolgern im Healthcare-Bereich.",
    paragraphs: [
      "Ob ärztliche Praxis, Labor oder medizinische Leitung—wir begleiten strukturierte Nachfolgeprozesse von der Profilierung bis zur Übergabe.",
      "Diskretion und Termintreue stehen im Mittelpunkt. So können Sie sich auf Ihre laufenden Aufgaben konzentrieren, während wir die Suche steuern.",
    ],
  },
  erfolgsgeschichten: {
    ...DEFAULT_HERO,
    title: "Referenzen",
    heroImage: null,
    intro:
      "Echte Besetzungen und zufriedene Mandanten: Einblicke in ausgewählte Projekte und Feedback von Kunden und Kandidaten.",
    paragraphs: [
      "Von der Facharztbesetzung in einer Klinik bis zur Leitung einer Medizintechnik-Abteilung—unsere Erfolgsgeschichten zeigen, wie wir gemeinsam mit unseren Partnern Ziele erreichen.",
      "Gerne teilen wir in einem vertraulichen Gespräch Referenzen und Fallbeispiele, die zu Ihrer Situation passen.",
    ],
  },
  garantien: {
    ...DEFAULT_HERO,
    title: "Garantien",
    intro:
      "Transparente Konditionen und faire Garantien: Wir stehen für Qualität und stehen zu unseren Leistungen.",
    paragraphs: [
      "Je nach Mandat vereinbaren wir Nachbesserungsgarantien und transparente Prozessschritte. So wissen Sie von Anfang an, woran Sie sind.",
      "Details zu Garantiezeiten und Konditionen besprechen wir individuell im Rahmen Ihres Suchauftrags.",
    ],
  },
  rekrutierungsprozess: {
    ...DEFAULT_HERO,
    title: "Rekrutierungsprozess",
    intro:
      "Von der Anforderungsanalyse bis zur Vertragsunterzeichnung: Unser strukturierter Rekrutierungsprozess im Überblick.",
    paragraphs: [
      "Wir starten mit einem detaillierten Briefing: Anforderungen, Kultur, Zeitrahmen. Darauf aufbauend erstellen wir ein Suchprofil und eine Suchstrategie.",
      "Anschließend folgen Identifikation, Kontaktaufnahme, Vorauswahl und Begleitung durch Vorstellungsgespräche bis zur Entscheidung und Einarbeitung.",
    ],
  },
  faq: {
    ...DEFAULT_HERO,
    title: "FAQ",
    intro:
      "Häufige Fragen zu unseren Leistungen, zum Ablauf und zu Konditionen. Für Mandanten und Kandidaten.",
    paragraphs: [
      "Wie lange dauert eine typische Besetzung? In der Regel zwischen wenigen Wochen und mehreren Monaten—abhängig von Rolle und Markt.",
      "Arbeiten Sie auch international? Ja, wir haben Zugang zu internationalen Märkten und unterstützen bei grenzüberschreitenden Suchaufträgen.",
      "Was kostet eine Zusammenarbeit? Unsere Honorare sind mandatsspezifisch. Gerne erstellen wir Ihnen ein unverbindliches Angebot.",
    ],
  },
  kandidatenreise: {
    ...DEFAULT_HERO,
    title: "Kandidatenreise",
    intro:
      "Was Sie als Kandidat bei REPEXO Medical erwartet: von der ersten Kontaktaufnahme bis zur Vertragsunterzeichnung.",
    paragraphs: [
      "Nach dem ersten Kontakt klären wir gemeinsam Ihre Wünsche, Stärken und Rahmenbedingungen. So können wir Sie nur mit passenden Mandaten ansprechen.",
      "Bei Interesse vermitteln wir den Kontakt zum Arbeitgeber und begleiten Sie durch Vorstellungsgespräche und Verhandlungen—diskret und auf Augenhöhe.",
    ],
  },
  kandidatenfeedback: {
    ...DEFAULT_HERO,
    title: "Kandidatenfeedback",
    intro:
      "Stimmen von Kandidaten, die wir bei ihrem nächsten Karriereschritt begleitet haben.",
    paragraphs: [
      "Wir legen Wert auf faire und transparente Kommunikation. Das Feedback unserer Kandidaten hilft uns, unseren Service kontinuierlich zu verbessern.",
      "Wenn Sie bereits mit uns zusammengearbeitet haben und uns eine Rückmeldung geben möchten, freuen wir uns über eine Nachricht.",
    ],
  },
  "faq-kandidaten": {
    ...DEFAULT_HERO,
    title: "FAQ für Kandidaten",
    intro:
      "Häufige Fragen von Kandidaten: Ablauf, Vertraulichkeit, Kosten und was Sie von uns erwarten können.",
    paragraphs: [
      "Kostet mich die Vermittlung etwas? Nein. Unsere Leistung wird vom Arbeitgeber getragen. Für Sie entstehen keine Kosten.",
      "Wird mein Arbeitgeber informiert? Nein. Wir behandeln alle Gespräche vertraulich und informieren Ihren Arbeitgeber nur mit Ihrer ausdrücklichen Zustimmung.",
      "Wie läuft das weitere Vorgehen ab? Nach einem ersten Kennenlernen vermitteln wir Sie nur bei passenden Mandaten und begleiten Sie durch die weiteren Schritte.",
    ],
  },
  blog: {
    ...DEFAULT_HERO,
    title: "Blog",
    intro:
      "Aktuelle Beiträge zu Themen rund um Recruiting, Karriere und den Healthcare-Arbeitsmarkt.",
    paragraphs: [
      "Hier finden Sie in Kürze Artikel zu Trends, Tipps und Einblicken in die Branche. Schauen Sie bald wieder vorbei.",
    ],
  },
  fallstudien: {
    ...DEFAULT_HERO,
    title: "Fallstudien",
    intro:
      "Ausgewählte Fallstudien: Wie wir Mandanten bei der Besetzung anspruchsvoller Positionen unterstützt haben.",
    paragraphs: [
      "Unsere Fallstudien geben—anonymisiert—Einblick in Ausgangslage, Vorgehen und Ergebnis. So können Sie unsere Arbeitsweise besser einschätzen.",
      "Gerne besprechen wir im persönlichen Gespräch Fallbeispiele, die zu Ihrer Situation passen.",
    ],
  },
  geschichte: {
    ...DEFAULT_HERO,
    title: "Geschichte",
    intro:
      "Wie REPEXO Medical entstanden ist und sich zu einer spezialisierten Personalberatung im Healthcare-Bereich entwickelt hat.",
    paragraphs: [
      "REPEXO Medical ist aus der Überzeugung entstanden, dass Recruiting im Gesundheitswesen besondere Branchenkenntnis und einen strukturierten, diskreten Ansatz erfordert.",
      "Seit unserer Gründung haben wir uns auf Direktansprache und Executive Search in Healthcare fokussiert und bauen kontinuierlich unser Netzwerk und unsere Prozesse aus.",
    ],
  },
  team: {
    ...DEFAULT_HERO,
    title: "Team",
    intro:
      "Die Menschen hinter REPEXO Medical: erfahrene Berater und Beraterinnen mit Hintergrund in Healthcare und Recruiting.",
    paragraphs: [
      "Unser Team vereint Branchenwissen mit Rekrutierungserfahrung. So verstehen wir sowohl die Anforderungen unserer Mandanten als auch die Motivation und Situation von Kandidaten.",
      "Wir arbeiten in kleinen, festen Teams und legen Wert auf langfristige Beziehungen zu Kunden und Kandidaten.",
    ],
  },
  "besetzte-positionen": {
    ...DEFAULT_HERO,
    title: "Besetzte Positionen",
    heroSubheading: "Auszug erfolgreich besetzter Positionen durch REPEXO medical.",
    heroIntro: "",
    heroCredibility: null,
    heroBottomParagraph: "",
    heroImage: null,
    paragraphs: [],
    positions: [
      "Mediziner verschiedenster Fachrichtungen ab Facharztniveau in Kliniken, Reha-Einrichtungen oder Privatpraxen, MVZs",
      "Leiter Verwaltung von medizinischen Einrichtungen",
      "Vertriebsmitarbeiter Medizintechnik",
      "Laborleiter",
      "Lebensmitteltechniker Produktentwicklung",
      "Chemiker",
      "Int. Koordinator Pharmazie",
      "Senior Manager Regulatory Affairs",
      "Project Manager",
      "Leitende Codierfachkraft",
      "Gruppenleiter Produktentwicklung Kosmetik",
      "Veterinärmediziner",
      "Gruppenleitung Hebammen",
      "Klinik-/Einrichtungsleiter",
      "Projektmanager klinische Forschung",
    ],
  },
  auszeichnungen: {
    ...DEFAULT_HERO,
    title: "Auszeichnungen",
    heroSubheading: "FOCUS Business TOP- Personalberater. Seit 2021 in Folge! ",
    heroIntro: "",
    heroCredibility: null,
    heroBottomParagraph: "",
    heroImage: null,
    paragraphs: [],
    awards: [
      {
        name: "FOCUS BUSINESS – TOP Personalberater",
        subtitle: "Focus TOP Personalberatung",
        years: "Seit 2021 in Folge",
        description:
          "Seit dem Jahr 2021 zeichnet das FOCUS Business Magazin auch die besten Personalberatungen am deutschen Makt aus. REPEXO bekommt seit 2021 für seine Leistungen in der Personalberatung, im verdeckten Arbeitsmarkt, das begehrte Siegel in Folge! Qualität bewährt sich.",
      },
    ],
  },
  social: {
    ...DEFAULT_HERO,
    title: "Soziale Medien",
    intro:
      "Folgen Sie uns auf unseren Kanälen für Neuigkeiten, Einblicke und Themen rund um Healthcare und Karriere.",
    paragraphs: [
      "Über unsere Social-Media-Profile teilen wir aktuelle Themen, Stellenangebote und Einblicke in unsere Arbeit. Wir freuen uns auf den Austausch mit Ihnen.",
    ],
  },
  kontakt: {
    ...DEFAULT_HERO,
    title: "Kontakt",
    intro:
      "Sie möchten mit uns zusammenarbeiten oder haben Fragen? So erreichen Sie uns.",
    paragraphs: [
      "Nutzen Sie das Kontaktformular auf dieser Seite oder schreiben Sie uns direkt. Wir melden uns zeitnah bei Ihnen.",
    ],
  },
};
